import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import Components from 'components';
import Plugins from 'plugins';
import Lity from 'lity';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function ($) {
    Components.init();
    Plugins.init();

    // Debugging: Log all elements with data-lity to ensure no duplicates
    $('[data-lity]').each(function() {
        console.log('Lity element:', this);
    });

    // Remove any existing click event on elements with data-lity to avoid duplicate bindings
    $(document).off('click', '[data-lity]');

    // Initialize Lity on elements with a specific class or attribute
    $(document).on('click', '[data-lity]', function (event) {
        console.log('Lity lightbox triggered');
        event.preventDefault(); // Prevent the default action to ensure Lity handles it
        Lity(event.currentTarget.getAttribute('href'));
    });
});


// CONT001 - Video play button
// Get references to elements
const video = document.getElementById("myVideo");
const playButton = document.getElementById("customPlayButton");
const playIcon = document.getElementById("playIcon");
const pauseIcon = document.getElementById("pauseIcon");

// Toggle play and pause on button click
if (playButton) {
    playButton.addEventListener("click", function () {
        if (video.paused) {
            video.play();
            playIcon.style.display = "none";
            pauseIcon.style.display = "inline";
        } else {
            video.pause();
            playIcon.style.display = "inline";
            pauseIcon.style.display = "none";
        }
    });
}

// Update button appearance based on video playback
if (video) {
    video.addEventListener("play", function () {
        playIcon.style.display = "none";
        pauseIcon.style.display = "inline";
    });

    video.addEventListener("pause", function () {
        playIcon.style.display = "inline";
        pauseIcon.style.display = "none";
    });
}

function startVideo() {
    const iframe = document.querySelector('#oembed-content iframe');
    if (iframe) {
        let src = iframe.src;
        src += (src.includes('?') ? '&' : '?') + 'autoplay=1';
        iframe.src = src;
    }
}

// Story Search Bar
const storySearch = {
    // Function to retrieve page content based on the search term
    retrievePageContent: (term) => {
        fetch(window.location.origin + `?s=${term}&post_type=story`)
            .then((response) => response.text())
            .then((data) => {
                storySearch.handlePageContent(data);
            });
    },

    // Function to handle autocomplete functionality
    autoComplete: (obj) => {
        const searchAutoComplete = obj.searchAutoComplete;

        // Function to retrieve and handle autocomplete data
        const retrieveCompleteData = (obj) => {
            fetch(window.location.origin + `?s=${obj.term}&post_type=story`)
                .then((response) => response.text())
                .then((data) => {
                    // Parsing HTML content
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(data, "text/html");
                    const autocompleteResult = doc.querySelector('li a div:last-child');

                    if (!autocompleteResult) {
                        return;
                    }

                    // Setting the autocomplete text content
                    searchAutoComplete.textContent = autocompleteResult.textContent;

                    // Adding event listener for 'Tab' key press
                    obj.input.addEventListener('keydown', (e) => {
                        if (e.key === 'Tab') {
                            e.preventDefault();
                            obj.input.value = searchAutoComplete.textContent;
                            storySearch.retrievePageContent(searchAutoComplete.textContent);
                            return;
                        }
                    });
                });
        }

        retrieveCompleteData(obj);
    },
    // Function to handle the retrieved page content
    handlePageContent: (data) => {
        const pagination = document.querySelector('.show002 .posts-pagination');
        const results = document.querySelector('[data-retrieve]');
        const loadMoreBtn = document.querySelector('.loadMoreBtn');

        if (!results || !loadMoreBtn) {
            return;
        }

        if (pagination) {
            pagination.classList.remove('hidden');
        }

        // Parsing HTML content
        let parser = new DOMParser();
        let doc = parser.parseFromString(data, "text/html");
        const dynamicResults = doc.querySelector('[data-dynamic]');

        if (!dynamicResults) {
            return;
        }

        // Removing all classes from the content
        doc.querySelectorAll('[class]').forEach((el) => {
            el.removeAttribute('class');
        });

        // Removing all navigation elements
        doc.querySelectorAll('nav').forEach((el) => {
            el.remove();
        });

        // Adding a specific class to certain elements
        doc.querySelectorAll('ul > li > article > div').forEach((elem) => {
            elem.classList.add('parentContainer');
        });

        // Updating the results section with the new content
        loadMoreBtn.classList.toggle('hidden');
        results.innerHTML = dynamicResults.innerHTML;
    },
    // Function to handle the case when there is no input
    noInput: (obj) => {
        const loadMoreBtn = document.querySelector('.loadMoreBtn');

        if (loadMoreBtn) {
            loadMoreBtn.classList.remove('hidden');
        }

        // Restore the initial results
        obj.results.innerHTML = obj.initialResults;
        obj.searchAutoComplete.textContent = '';
    },
    // Function to initialize and manage the search input and results
    listPageContent: () => {
        const input = document.querySelector('.searchQuery');
        const results = document.querySelector('[data-retrieve]');
        const searchAutoComplete = document.querySelector('.searchAutoComplete');

        if (!input || !results || !searchAutoComplete) {
            return;
        }

        let initialResults = results.innerHTML;
        let timeout = null;

        // Adding event listener for input changes
        input.addEventListener('input', (e) => {
        
            let term = e.target.value;

            if (term !== '') {
                storySearch.autoComplete({ input, term, searchAutoComplete });
            }

            if (term === '') {
                clearTimeout(timeout);
                storySearch.noInput({ results, initialResults, searchAutoComplete });
                return;
            }


            clearTimeout(timeout);

            // Setting a timeout to fetch the page content after a delay
            timeout = setTimeout(() => {
                storySearch.retrievePageContent(term);
            }, 500);
        });

        // Handle load more button click

    }
};

// Initializing the search functionality
storySearch.listPageContent();


document.addEventListener("DOMContentLoaded", function() {
    // Check if the URL has the 'pg' parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('pg')) {
        // Scroll to the 'search-populate' section
        const searchPopulate = document.querySelector('.search-populate');
        if (searchPopulate) {
            searchPopulate.scrollIntoView({ behavior: 'smooth' });
        }
    }
});
